<template>
    <div>
        <b-row align-v="center">
            <b-col cols="12" lg="3">
                <app-form-input @keyup.enter="filter" label="Nombre reunión" v-model="filters.name"></app-form-input>
            </b-col>
            <b-col cols="12" lg="3">
                <app-form-input @keyup.enter="filter" label="Moderador" v-model="filters.hostName"></app-form-input>
            </b-col>
            <b-col cols="12" lg="3">
                <app-form-input @keyup.enter="filter" type="date" label="Desde" v-model="filters.from"></app-form-input>
            </b-col>
            <b-col cols="12" lg="3">
                <app-form-input @keyup.enter="filter" type="date" label="Hasta" v-model="filters.to"></app-form-input>
            </b-col>
            <b-col cols="12" lg="3">
                <app-form-select @keyup.enter="filter" v-model="filters.meetingTypeId" label="Tipo" :options="meetingTypes"></app-form-select>
            </b-col>
            <b-col cols="12" lg="3">
                <app-form-select @keyup.enter="filter" v-model="filters.clientId" label="Cliente / Aliado" :options="clients"></app-form-select>
            </b-col>
            <b-col cols="12" lg="6" class="text-right">
                <b-btn size="sm" variant="primary" @click="filter"><i class="fas fa-filter"></i></b-btn>
                <b-btn size="sm" variant="secondary" @click="clear"><i class="fas fa-times"></i></b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data: () => ({
        filters: {
            name: '',
            hostName: '',
            from: '',
            to: '',
            meetingTypeId: '',
            clientId: '',
        },
        meetingTypes: [],
        clients: [],
    }),
    computed: {
        //
    },
    methods: {
        filter() {
            this.$emit('filter', this.filters)
        },
        clear() {
            Object.keys(this.filters).map(key => this.filters[key] = '')
            this.$emit('filter', null)
        },
        async loadMeetingTypes() {
            const {data} = await this.$repo.get('meeting-types')
            this.meetingTypes = data
        },
        async loadClients() {
            const {data} = await this.$repo.get('clients')
            this.clients = data
        }
    },
    created() {
        this.loadMeetingTypes()
        this.loadClients()
    }
}
</script>
